module.exports = __webpack_public_path__ + "static/img/headImage.ef7a3b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/headImage.jpg
// module id = Tmfi
// module chunks = 1